//
//
//
//
//
//

import Content from './Content.vue'
export default {
  components: { Content },
  props: {
    source: {
      type: String,
      required: true
    },
    content: {
      type: String,
      default: ''
    },
    javascript: {
      type: String,
      default: null
    }
  },
  mounted() {
    const newScript = document.createElement('script')
    newScript.src = this.source
    newScript.async = true

    newScript.onload = () => {
      // eslint-disable-next-line no-eval
      eval(this.javascript)
    }

    this.$refs.element.appendChild(newScript)
  }
}
